import {memo} from 'react';

import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';

import {ModifiedCreditCard} from './types';
import CreditCardsDropdown from './components/CreditCardsDropdown';
import {Header, Explanation} from './components/styled';

const Root = styled.div`
  width: 100%;
  padding-bottom: 32px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
`;

const StyledCreditCardsDropdown = styled(CreditCardsDropdown)`
  margin-top: 20px;
`;

type OtlCreditCardListProps = {
  creditCardList?: ModifiedCreditCard[];
  selectedCreditCard: number | null;
  setSelectedCreditCard: (creditCardId: number | null) => void;
  addCreditCard: () => void;
};

const OtlCreditCardList = ({
  creditCardList,
  selectedCreditCard,
  setSelectedCreditCard,
  addCreditCard,
}: OtlCreditCardListProps) => {
  const {t} = getLocalizationService();
  return (
    <Root>
      <Header>{t('credit_card_to_charge')}</Header>
      <Explanation>{t('this_is_the_card_we_will_charge_when_your_10bis_budget_runs_out')}</Explanation>
      <StyledCreditCardsDropdown
        creditCardList={creditCardList}
        selectedCreditCard={selectedCreditCard}
        setSelectedCreditCard={setSelectedCreditCard}
        addCreditCard={addCreditCard}
      />
    </Root>
  );
};

export default memo(OtlCreditCardList);
